import React, { FunctionComponent } from "react";
import { IonIcon, IonImg, IonLabel } from "@ionic/react";
import { cloudOffline } from "ionicons/icons";
import { SiteItemModel } from "../models/site-item.model";
import { useSitePhotoUri } from "../../shared/hooks/use-site-photo-uri.hook";
import alphanumericIcon from '../../../icons/alphanumeric.svg';
import { LoadingSiteListComponent } from './loading-site-list.component';
import { useTranslation } from 'react-i18next';

export const SiteItem: FunctionComponent<{ site: SiteItemModel }> = ({ site }) => {
  const { photoURI, handlerImageError } = useSitePhotoUri(site);
  const { t } = useTranslation();

  return (
    <>{ site == null ? (<LoadingSiteListComponent message={ t('site.loadingMessage') }/>) : (
      <>
        <div
          style={{ 
            position: 'relative', 
            width: '100px', 
            margin: '0',
            padding: '0',
            flexShrink: 0,
            alignSelf: 'stretch',
            borderRadius: '6px 0 0 6px',
            overflow: 'hidden'
          }}>
          <IonImg 
            src={ photoURI } 
            onIonError={ handlerImageError }
            style={{
              position: 'absolute',
              top: '0',
              left: '0',
              right: '0',
              bottom: '0',
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }}
          />
          { site.isOffline && (
            <IonIcon
              style={{ position: 'absolute', bottom: 3, left: 5, fontSize: 20 }}
              icon={ cloudOffline }
              color={ 'secondary' }
            />
          )}
        </div>
      
        <div style={{ 
          display: 'flex', 
          flexDirection: 'column',
          flex: 1,
          padding: '8px'
        }}>
          <div style={{ display: 'flex', alignItems: 'center'}}>
            { site.numberOfAnnotations > 0 && (
              <IonLabel
                style={{
                  fontSize: '0.4rem',
                  color: '#FDFDFD',
                  backgroundColor: '#FF8402',
                  borderRadius: '12px',
                  width: '15px',
                  height: '15px',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '2px 2px 2px 2px',
                  gap: '10px',
                  verticalAlign: 'middle',
                  fontWeight: '500',
                  marginRight: '5px',
                  minWidth: '15px',
                  minHeight: '15px',
                  boxSizing: 'border-box'
                }}
              >
                {site.numberOfAnnotations > 99 ? '99+' : site.numberOfAnnotations}
              </IonLabel>
            )}
            <IonLabel style={{ 
              fontSize: '10px',
              display: 'inline-block',
              verticalAlign: 'middle',
              fontFamily: 'Open Sans, sans-serif',
              fontWeight: 400,
              lineHeight: '1',
              letterSpacing: '0.5px',
              color: '#165BE6'
            }} color={ 'tertiary' }>
              { site.address }
            </IonLabel>
          </div>

          <div style={{ display: 'flex', alignItems: 'center' }}>
            {!site.isGraphic && (
              <img src={alphanumericIcon}
                style={{width: '18px', height: '18px', marginRight: '5px', display: 'inline-block', verticalAlign: 'middle'}}
                alt=""
              />
            )}
            <span style={{
              fontSize: '14px',
              lineHeight: '1.5',
              display: 'inline-block',
              verticalAlign: 'middle',
              fontFamily: 'Open Sans, sans-serif',
              fontWeight: 600,
              letterSpacing: '0.5px',
              color: '#191A20'
            }}>
              {site.name}
            </span>
          </div>
          
          {(site.isExported || site.numberOfExportedBuildings > 0) && (
            <IonLabel
              style={{
                fontSize: '0.7rem',
                color: '#CA6700',
                backgroundColor: '#FAECE3',
                borderRadius: '4px',
                height: '20px',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '2px 8px 2px 8px',
                gap: '6px',
                verticalAlign: 'middle',
                fontWeight: '500',
                marginTop: '4px',
                width: 'fit-content'
              }}
            >
              {site.isExported && site.numberOfExportedBuildings === 0 && (
                t('sites.site_exported')
              )}
              {site.isExported && site.numberOfExportedBuildings > 0 && (
                t('sites.site_and_building_exported', {
                  exportedBuildings: site.numberOfExportedBuildings,
                  totalBuildings: site.numberOfBuildings,
                })
              )}
              {!site.isExported && site.numberOfExportedBuildings > 0 && (
                t('sites.building_exported', {
                  exportedBuildings: site.numberOfExportedBuildings,
                  totalBuildings: site.numberOfBuildings,
                })
              )}
            </IonLabel>
          )}
        </div>
      </>
    )}</>
  );
};
